import { Injectable }               from '@angular/core';
import { Http }                     from '@angular/http';
import { ISortableFilter }          from './../common/sortable-filter';
import { Globals }                  from './../common/globals';
import { AuthHttp }                 from 'angular2-jwt';
import { Observable }               from 'rxjs/Observable';
import { GridInterfaceService }     from './grid.interface.service';
import { CommonService }            from './common.service';
import { MatSnackBar }               from '@angular/material';

@Injectable()
export class TrainCycleService implements GridInterfaceService {

    private _commonService: CommonService;
    constructor(public authHttp: AuthHttp, private http: Http, private globals: Globals, public snackbar: MatSnackBar) {
        this._commonService = new CommonService(authHttp, http, globals, 'trainCycle', snackbar);
    }

    public getItems(filter: ISortableFilter): Observable<any> {
        return this._commonService.getItems(filter);
    }

    public insertItem(item: any): Observable<any> {
        return this._commonService.insertItem(item);
    }

    public updateItem(id: string, item: any): Observable<any> {
       return this._commonService.updateItem(id, item);
    }

    public updateOrder(id: string, item: any): Observable<any> {
        return this._commonService.updateItem('updateOrder/' + id, item);
    }

    public deleteItem(id: string): Observable<any> {
        return this._commonService.deleteItem(id);
    }

    public isCycleAssigned(cycleUID: string): Observable<any> {
        return this._commonService.get('/isCycleAssigned/' + cycleUID);
    }

    public cycleTrainOrder(cycleUID: string): Observable<any> {
        return this._commonService.get('/cycleTrainOrder/' + cycleUID);
    }

    public pdf(filter: ISortableFilter, columnParams: Array<any>, pageOrientation: string = null) {
        this._commonService.pdf(filter, columnParams, pageOrientation);
    }

    public csv(filter: ISortableFilter, columnParams: Array<any>, pageOrientation: string = null) {
        this._commonService.csv(filter, columnParams, pageOrientation);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/train-cycle.service.ts